<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="save('userForm')" :disabled="formsData.userForm.disabled">
                <span>Save</span>
            </ion-button>
        </ion-buttons>
        <ion-title>Emergency Contact</ion-title>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <el-form :model="formsData.userForm" :rules="formsData.userForm.rules" :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')" @keyup.enter="goNext('userForm')">
            <div class="settings_menu">
                <div class="menu_title">
                    <span>Contact Details</span>
                </div>
            </div>
            <div class="form_part">
                <el-form-item label="Name" prop="firstName">
                    <el-input v-model="formsData.userForm.firstName.value" autocomplete="off" placeholder="Given Name" :maxlength="20" @keyup="formsData.userForm.firstName.value = $event.target.value"></el-input>
                </el-form-item>
                <el-form-item label="Mobile Number" prop="mobileNumber" :required='true'>
                    <div class="el-input">
                        <vue-tel-input class="el-input__inner" :value="formsData.userForm.mobileNumber.valueFormatted" v-model="formsData.userForm.mobileNumber.value" :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false" @input="onPhoneInput" v-bind="{mode: 'international'}" @blur="checkFormValidation('userForm', true, 'mobileNumber')"></vue-tel-input>
                    </div>
                </el-form-item>
            </div>
        </el-form>
    </div>
</template>


<script>
    import {
        onMounted,
        inject,
        defineAsyncComponent,
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        IonTitle,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
        onBeforeRouteLeave,
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'

    const VueTelInput = defineAsyncComponent(() => import('@/components/Vendor/vue-tel-input/components/vue-tel-input.vue'))

    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            IonTitle,

            VueTelInput,
        },
        directives: {

        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const setPageClassGlobal = inject(['setPageClassGlobal']);

            const userData = $store.getters.GET_USER_DATA;

            const formsDataArray = {
                userForm: {
                    firstName: {
                        value: userData.emergencyContact.firstName || '',
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'firstName', callback, setFormValidation);
                            },
                        }]
                    },

                    mobileNumber: {
                        ref: {},
                        value: userData.emergencyContact.mobileNumber || '',
                        valueFormatted: userData.emergencyContact.mobileNumber || '',
                        resetValue: true,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                console.log(formField);
                                formValidate.validate(rule, formField, 'mobileNumber', callback, setFormValidation);
                            },
                        }],
                        errors: null
                    },
                }
            };

            let mobileNumberInit = false;

            const onPhoneInput = (value, phoneObject) => {
                if (!value.target) {
                    formsData.userForm.mobileNumber.ref.phoneObject = phoneObject
                }
                formsData.userForm.mobileNumber.valueFormatted = value.target ? value.target.value : value;
                formsData.userForm.mobileNumber.value = formsData.userForm.mobileNumber.ref.phoneObject.number || null

                checkFormValidation('userForm', false, 'mobileNumber');
                if (!mobileNumberInit) {
                    checkFormValidation('userForm', true, 'mobileNumber');
                    mobileNumberInit = true;
                }
            };

            const goBack = () => {
                $router.push({
                    name: 'profile'
                })
            };

            const save = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {
                        return (async () => {
                            try {
                                checkFormChanged('userForm', true);
                                console.log(getFormValues(formName));
                                await $store.dispatch('SAVE_USER_DATA', {
                                    emergencyContact: getFormValues(formName)
                                });
                                copyFormResetValue('userForm', true);
                                goBack();
                            } catch (errors) {
                                // for (let key in errors) {

                                // setFieldError('userForm', key, error.errors[key]);
                                // }
                                console.log(errors);
                            }
                        })();
                    } else {
                        setFormValidation(formName, false, false);
                        console.log('error submit!!');
                        return false;
                    }
                });
            }

            onBeforeRouteLeave((to, from, next) => {
                (async () => {
                    try {
                        let leave = await checkFormChanged('userForm');
                        if (leave == 'save') {
                            await save('userForm');
                        } else if (!leave) {
                            next(false)
                        } else {
                            next()
                        }
                    } catch (error) {
                        next(false);
                        console.log(error);
                    }
                })();
            })

            onMounted(() => {
                setPageClassGlobal('global_profile_page');
                setFormRefs();
                checkFormValidation('userForm', true);
            });

            const {
                checkFormValidation,
                setFormValidation,
                copyFormResetValue,
                checkFormChanged,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                checkFormValidation,
                goBack,
                save,
                onPhoneInput
            }
        },
    }
</script>